import React, {createContext, useEffect, useState} from 'react';
import getOidcServiceInstance from "./EIDOidcSingletonService";
import {API} from "aws-amplify";

const EidAuthContext = createContext();

const EidAuthProvider = ({children}) => {
    const [eidOidcService, setOidcService] = useState(null);
    const [eidUser, setEidUser] = useState(() => {
        const eidAuthUserSessionKey = `eid.auth.user:${window.__RUNTIME_CONFIG__.TOPNAV_BASE_API_URL_OVERRIDE}:${window.__RUNTIME_CONFIG__.EID_CLIENT_ID}`;
        const eidUserInSession = localStorage.getItem(eidAuthUserSessionKey);
        if (!eidUserInSession || eidUserInSession === 'undefined' || eidUserInSession === 'null') {
            return null;
        }
        try {
            return JSON.parse(eidUserInSession);
        } catch (error) {
            console.error('Invalid JSON in localStorage for eidUser:', error);
            return null;
        }
    });

    useEffect(() => {
        let oidcInstance, handleAccessTokenExpired;
        const initializeEidSdk = async () => {
            oidcInstance = await getOidcServiceInstance();
            setOidcService(oidcInstance);
            handleAccessTokenExpired = () => {
                eidUserSignOut();
            };
            oidcInstance?.events.addAccessTokenExpired(handleAccessTokenExpired);
            try {
                let currentUser = await oidcInstance?.getUser();
                if (currentUser) setEidUser(currentUser);
            } catch (error) {
                console.error('Error during user retrieval:', error);
                setEidUser(null);
            }

        };
        initializeEidSdk();
        return () => {
            if (oidcInstance?.events) {
                oidcInstance.events.removeAccessTokenExpired(handleAccessTokenExpired);
            }
        };
    }, []);

    const setSignInEidUser = (eidUser) => {
        setEidUser(eidUser);
    };

    const eidUserSignOut = async () => {
        try {
            const oidcInstance = eidOidcService || await getOidcServiceInstance();
            await oidcInstance?.signOut();
        } catch (error) {
            console.error('Error during sign-out:', error);
        }
    };

    return (
        <EidAuthContext.Provider value={{eidUser, setSignInEidUser, eidUserSignOut}}>
            {children}
        </EidAuthContext.Provider>
    );
};

export {EidAuthContext, EidAuthProvider};